import hubAPI from "../services/hubAPI";
import {
  generateUID,
  setHardFilter,
  getHardFilter,
  getTempFilter,
  setTempFilter,
  getDataLayerNormalizedString,
} from "../common/utils";

export class HubContextService {
  locale = localStorage.getItem("locale") || "en-US";
  theme = getHardFilter("app-theme") || "blue";
  companyID = localStorage.getItem("companyID");
  company = {
    companyID: localStorage.getItem("companyID"),
    companySubscriptions: [],
  };
  companies = [];
  sideBarItems = [];
  breadcrumbs = [];
  kpis = [];
  globalStatus = [];
  filterCatalogs = null;
  filterValues = [];
  widgetGroups = [];
  dashboards = [];
  currentDashboard = null;
  dashHandler = null;
  dragAndDropEnabled = !!localStorage.getItem("dragAndDropEnabled")
    ? localStorage.getItem("dragAndDropEnabled") === "true"
    : false;
  lockWorkArea = false;
  optionsTitlePanel = !!localStorage.getItem("optionsTitlePanel")
    ? JSON.parse(localStorage.getItem("optionsTitlePanel"))
    : ["popUp", "analysis", "changeChartType", "filters"];
  expiredSession = false;
  alertNotifications = [];
  /***/
  filters = [];
  globalFilter = [];
  pivotGlobalFilter = "";
  dashboardWidgetGroups = [];
  customLayout = localStorage.getItem("customLayout") === "on";
  restoreOriginalLayOut = null;

  setOptionsTitlePanel = (value) => {
    this.optionsTitlePanel = value;
    localStorage.setItem("optionsTitlePanel", JSON.stringify(value));
  };

  setExpiredSession = (value) => (this.expiredSession = value);

  setLocale = (value, callBack) => {
    this.locale = value;
    localStorage.setItem("locale", value);
    if (typeof callBack === "function") callBack();
  };

  setTheme = (value) => {
    this.theme = value;
    setHardFilter("app-theme", value);
  };

  setCompanyID = (value) => {
    const selectedCompany = this.companies.filter((x) => x.companyID === value);

    let lockWorkArea = false;
    if (
      selectedCompany.length > 0 &&
      selectedCompany[0].companySubscriptions.length > 0
    ) {
      const subscription = selectedCompany[0].companySubscriptions[0];
      lockWorkArea = subscription.isTrial ? subscription.lockWorkArea : false;
    }

    //US43662: Almacenar filtros y grupos en storage local
    const storedHardFilterValues = getHardFilter(
      `context-filter-values-${value || 0}`,
    );
    const storedTempFilterValues = getTempFilter(
      `context-filter-values-${value || 0}`,
    );
    const filterValues = [
      ...(storedHardFilterValues || []),
      ...(storedTempFilterValues || []),
    ];

    this.filterValues = filterValues;
    this.lockWorkArea = lockWorkArea;
    this.sideBarItems = [];
    this.companyID = value;
    this.setCompany(selectedCompany.length > 0 ? selectedCompany[0] : null);
  };

  setAlertNotifications = (value) => {
    if (isNaN(value) || (value || 0) <= 0) return;

    hubAPI
      .get(`/api/v1/Company/${value}/alertNotification`)
      .then((response) => {
        this.alertNotifications = response.data;
      })
      .catch((_) => {
        this.alertNotifications = [];
      });
  };
  setCompany = (value) => {
    let lockWorkArea = false;
    if (
      !!value &&
      !!value.companySubscriptions &&
      value.companySubscriptions.length > 0
    ) {
      const subscription = value.companySubscriptions[0];
      lockWorkArea = subscription.isTrial ? subscription.lockWorkArea : false;
    }

    //US43662: Almacenar filtros y grupos en storage local
    const storedHardFilterValues = getHardFilter(
      `context-filter-values-${value?.companyID || 0}`,
    );
    const storedTempFilterValues = getTempFilter(
      `context-filter-values-${value?.companyID || 0}`,
    );
    const filterValues = [
      ...(storedHardFilterValues || []),
      ...(storedTempFilterValues || []),
    ];

    this.filterValues = filterValues;
    this.companyID = !!value ? value.companyID : 0;
    this.company = value;
    this.lockWorkArea = lockWorkArea;
    this.sideBarItems = [];
    localStorage.setItem("companyID", !!value ? value.companyID : 0);
  };
  setCompanies = (value) => (this.companies = value);
  setSideBarItems = (value) => (this.sideBarItems = value);
  setBreadCrumb = (values) => {
    this.breadcrumbs = values;
    const pageTitle =
      (values || []).find((e) => e.type === "title")?.text || "GoHub Edenred";
    document.title = pageTitle;
  };
  setKpis = (value) => (this.kpis = value);
  setGlobalStatus = (value) => (this.globalStatus = value);
  setFilterCatalogs = (value) => {
    this.filterCatalogs = value;
    try {
      localStorage.setItem("filterCatalogs", JSON.stringify(value));
    } catch (error) {
      localStorage.removeItem("filterCatalogs");
      console.log(error, "Error saving filterCatalogs");
    }
  };
  setFilterValues = (filters, widgetGroups) => {
    this.filterValues = filters;
    this.widgetGroups = widgetGroups;

    //US43662: Almacenar filtros y grupos en storage local
    const toExcludeHard = ["endDate", "startDate"];
    let toStoreFilters = filters
      .filter((x) => toExcludeHard.indexOf(x.key) < 0)
      .filter((x) => !!x)
      .filter((x) => !Array.isArray(x.value) || x.value.length > 0);
    setHardFilter(
      `context-filter-values-${this.company?.companyID || 0}`,
      toStoreFilters,
    );

    let toStoreFiltesTemp = filters
      .filter((x) => toExcludeHard.indexOf(x.key) >= 0)
      .filter((x) => !!x)
      .filter((x) => !Array.isArray(x.value) || x.value.length > 0);
    setTempFilter(
      `context-filter-values-${this.company?.companyID || 0}`,
      toStoreFiltesTemp,
    );

    setTempFilter(`context-widget-groups`, widgetGroups);
  };
  setDashboards = (value) => {
    (value || []).forEach((dashboard) => {
      if (!dashboard.settings) dashboard.settings = {};
      else if (typeof dashboard.settings === "string")
        dashboard.settings = JSON.parse(dashboard?.settings || "{}");
      else dashboard.settings = dashboard.settings || {};

      (dashboard.dashboardWidgets || []).forEach((widget) => {
        if (!widget.settings) widget.settings = {};
        else if (typeof widget.settings === "string")
          widget.settings = JSON.parse(widget?.settings || "{}");
        else widget.settings = widget.settings || {};
      });

      //Exclusivo v2
      if ([2].indexOf(dashboard.settings?.version || 1) >= 0) {
        dashboard.dashboardWidgets.forEach((widget) => {
          widget._uid = widget._uid || generateUID();

          if (!widget.customSettings) widget.customSettings = {};
          else if (typeof widget.customSettings === "string")
            widget.customSettings = JSON.parse(widget?.customSettings || "{}");
          else widget.customSettings = widget.customSettings || {};

          if (!widget.settings.items) widget.settings.items = [];
          if (!widget.customSettings.items) widget.customSettings.items = [];

          (widget.customSettings.items || []).forEach((cs) => {
            for (let i = 0; i < widget.settings.items.length; i++) {
              if (widget.settings.items[i].key === cs.key)
                widget.settings.items[i] = {
                  ...widget.settings.items[i],
                  ...cs,
                };
            }
          });

          widget.settings.items.forEach(
            (item) => (item._uid = item._uid || generateUID()),
          );

          //2 periods compare
          if (!widget.settings.compare) widget.settings.compare = null;
          else {
            if (!widget.settings.compare.dateCalc)
              widget.settings.compare.dateCalc = widget.dateCalc;
          }

          if (!widget.settings.export) widget.settings.export = [];
        });
      }
    });
    this.dashboards = value;
  };
  setDashHandler = (value) => (this.dashHandler = value);
  setCurrentDashboard = (value, intl, callBack) => {
    this.currentDashboard = value;

    document.title = `${
      intl?.formatMessage({ id: "dashboard", defaultMessage: "Dashboard" }) ||
      "GoHub Edenred"
    } - ${this.currentDashboard?.name || ""}`;
    if (document.body.classList.contains("dash-v2"))
      document.body.classList.remove("dash-v2");

    if (!!value && !!value.settings && (value.settings.version || 1) === 2) {
      document.body.classList.add("dash-v2");
    }

    if (callBack && typeof callBack === "function") callBack();

    //54613 [Improvement] – Tagging specification
    if (!!this.currentDashboard)
      window.dataLayer.push({
        event: "hero_edenred_page_view",
        page: `/${getDataLayerNormalizedString(this.currentDashboard?.name || "")}`,
      });
  };
  setCurrentDashboardWidgetSort = (items) => {
    if (!this.currentDashboard) return;

    this.currentDashboard.dashboardWidgets.forEach((widget) => {
      items.forEach((item, i) => {
        if (widget.dashboardWidgetID === item.id) {
          widget.sort = i;
        }
      });
    });
    const layouts = this.currentDashboard.dashboardWidgets.map((x) => {
      return {
        userID: "*",
        dashboardWidgetID: x.dashboardWidgetID,
        x: x.xs,
        y: x.sm,
        w: x.lg,
        h: x.xl,
        sort: x.sort,
        customSettings: !x.customSettings
          ? "{}"
          : JSON.stringify(x.customSettings),
      };
    });
    hubAPI
      .post(
        `api/v1/Dashboard/${this.currentDashboard.dashboardID}/widgetlayout?culture=${this.locale}`,
        layouts,
      )
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  setDragAndDropEnabled = (value) => {
    this.dragAndDropEnabled = value;
    localStorage.setItem(
      "dragAndDropEnabled",
      !!this.dragAndDropEnabled ? "true" : "false",
    );
  };

  setFilters = (value) => (this.filters = value);
  setGlobalFilter = (filters, dashboardWidgetGroups) => {
    let dwg =
      dashboardWidgetGroups === undefined
        ? this.dashboardWidgetGroups
        : dashboardWidgetGroups;

    this.globalFilter = filters;
    this.dashboardWidgetGroups = dwg;
  };
  setPivotGlobalFilter = (value) => (this.pivotGlobalFilter = value);
  setDashboardWidgetsGroups = (value) => (this.dashboardWidgetsGroups = value);
  setCustomLayout = (value) => (this.customLayout = value);
  setRestoreOriginalLayOut = (value) => (this.restoreOriginalLayOut = value);
}
